import random from 'toxilibs/random.js'

const transforms = [
    {
        upIsUp: true,
        aspectRatioPreserved: true,
        map: () => {},
        code: {}
    },
    {
        upIsUp: true,
        aspectRatioPreserved: true,
        map: (map) => map.flip('horizontal'),
        code: {
            left:  'right',
            right: 'left'
        }
    },
    {
        aspectRatioPreserved: true,
        map: (map) => map.flip('vertical'),
        code: {
            up:   'down',
            down: 'up'
        }
    },
    {
        map: (map) => map.rotate(90),
        code: {
            up:    'left',
            down:  'right',
            left:  'down',
            right: 'up'
        }
    },
    {
        aspectRatioPreserved: true,
        map: (map) => map.rotate(180),
        code: {
            up:    'down',
            down:  'up',
            left:  'right',
            right: 'left'
        }
    },
    {
        map: (map) => map.rotate(-90),
        code: {
            up:    'right',
            down:  'left',
            left:  'up',
            right: 'down'
        }
    },
    {
        map: (map) => {
            map.flip('horizontal')
            map.rotate(90)
        },
        code: {
            up:    'left',
            down:  'right',
            left:  'up',
            right: 'down'
        }
    },
    {
        map: (map) => {
            map.flip('horizontal')
            map.rotate(-90)
        },
        code: {
            up:    'right',
            down:  'left',
            left:  'down',
            right: 'up'
        }
    }

]


function applyTransform (challengeData) {
    let transform = pickTransform(challengeData)
    challengeData.mapTransform = transform.map
    challengeData.code = challengeData.code
        .toString()
        .replace(/(up|down|left|right)/gm, (direction) => transform.code[direction] || direction)
}


function pickTransform (challengeData) {
    let userId = localStorage && localStorage.getItem('userId')
    random.setSeed(userId + challengeData.id)

    if (challengeData.keepUpUp) {
        return random.pick(transforms.filter(t => t.upIsUp))
    }

    if (challengeData.keepAspectRatio) {
        return random.pick(transforms.filter(t => t.aspectRatioPreserved))
    }

    if (challengeData.noTransform) {
        return transforms[0]
    }

    return random.pick(transforms)
}

export default applyTransform
